import { type ReactNode } from 'react';

import PageMeta from '@/shared/components/PageMeta';
import type { Props as PageMetaProps } from '@/shared/components/PageMeta';

type Props = {
  readonly children: ReactNode;
  readonly pageMeta: PageMetaProps;
};

const FirstScreenLayout = ({ children, pageMeta }: Props) => (
  <>
    <PageMeta {...pageMeta} />
    <div className="flex w-full flex-1 flex-col">{children}</div>
  </>
);

export default FirstScreenLayout;
